module.exports = __webpack_public_path__ + "static/benef2_vert-d370ae222a49f15218dd03b998900644.jpg";